import Text from '$tablet-app/src/app/components/Text';
import { palette } from '$tablet-app/src/app/theme';
import { ChecklistModel } from '@akin-home/checklists';
import React, { FC } from 'react';
import styled from 'styled-components/native';

interface Props {
  item: ChecklistModel;
  onPress?(item: ChecklistModel): void;
}

const ChecklistBulletTile: FC<Props> = ({ item, ...props }) => {
  const onPress = () => props.onPress?.(item);

  return (
    <Container onPress={onPress}>
      <Text weight="semibold">{item.title}</Text>

      {item.checklist.map((list_item) => (
        <ChecklistItem key={list_item.id}>
          <Text>{'\u2022'}</Text>
          <Text>{list_item.title}</Text>
        </ChecklistItem>
      ))}
    </Container>
  );
};

const Container = styled.TouchableOpacity`
  padding: 8px;
  border-radius: 10px;

  background-color: ${palette.Sky_blue};
`;

const ChecklistItem = styled.View`
  flex-direction: row;

  padding-vertical: 4px;

  gap: 16px;
`;

export default ChecklistBulletTile;
